import Affiliation from './Affiliation.jsx';
import Boards from './Boards.jsx';
import BsAlert from '../common_components/BsAlert';
import Members from './Members.jsx';
import IgMeetings from '../IgMeetings.jsx';
import React from 'react';
import Unauthorized from './Unauthorized';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { injectIntl } from 'react-intl';
import { inject } from 'mobx-react';
import {
  Row,
  Col,
  Grid,
  Tab,
  Nav,
  NavItem,
  Glyphicon,
  Button
} from 'react-bootstrap';
import MainTooltips from '../common_components/tooltips/MainTooltips';
import { SECTIONS_DATA, TOOLS } from '../igroadmap_components/constants';
import IgPanel from '../common_components/IgPanel.jsx';
import IgBusinessWrapper from '../common_components/wrappers/IgBusinessWrapper.jsx';
import BmcBoardWrapper from '../common_components/wrappers/BmcBoardWrapper.jsx';
import { STARTUP_SECTIONS } from '../igmvp_components/models/constants.js';
import SaveButtonWithConfirmation from '../common_components/SaveButtonWithConfirmation';
import { INSTRUCTIONAL_ROUTES } from '../instructional_feed_components/constants.js';
import { RenderInstructional } from '../instructional_feed_components/RenderInstructional.jsx';
import ProfileModal from './ProfileModal';

const BASE_SECTIONS = [
  TOOLS.IGINFRASTRUCTURE,
  TOOLS.IGBUSINESS,
  'affiliation',
  'memberships',
  'boards',
  'meetings'
];

const INSTRUCTIONAL_SECTIONS = ['affiliation', 'memberships', 'boards'];

const ROUTES = {
  iginfrastructure: TOOLS.IGINFRASTRUCTURE,
  igbusiness: TOOLS.IGBUSINESS,
  affiliation: 'igaffiliation',
  memberships: 'igteam',
  boards: 'igboard',
  meetings: 'igmeetings'
};

@inject('affiliationStore', 'membersStore', 'rootStore')
@injectIntl
@withRouter
export default class Main extends React.Component {
  constructor(props) {
    super(props);
  }

  renderFinishButton = () => {
    const { intl, currentStartupId } = this.props;

    return (
      <div style={{ marginBottom: 20, textAlign: 'center' }}>
        <SaveButtonWithConfirmation
          toggleButtonClassName="btn-primary"
          onConfirm={() =>
            (window.location = `${INSTRUCTIONAL_ROUTES.ceo(
              intl.locale,
              currentStartupId
            )}`)
          }
        />
      </div>
    );
  };

  render() {
    let { affiliationStore, membersStore, rootStore } = this.props;
    const { tooltipStore, modal } = rootStore;

    const MEMBERSHIPS_SECTIONS = BASE_SECTIONS;

    return (
      <React.Fragment>
        <MainTooltips
          customJoyrideProps={{
            scrollToFirstStep: false,
            spotlightClicks: true
          }}
        />
        <ProfileModal />
        <RenderInstructional section={modal} show={modal == 'infrastructure'} />
        <BsAlert rootStore={this.props.rootStore} />
        <Grid className="full-page infrastructure">
          <Row className="clearfix">
            <Col xs={12}>
              <Tab.Container id="tabs">
                <Row>
                  <Col xs={12} className="wizard product">
                    <div className="wizard-inner">
                      <div
                        className="connecting-line"
                        style={{
                          width: `${100 - 100 / MEMBERSHIPS_SECTIONS.length}%`
                        }}
                      />
                      <Nav className="nav-tabs">
                        {MEMBERSHIPS_SECTIONS.map((path, idx) => (
                          <NavItem
                            key={path}
                            disabled={
                              modal == 'infrastructure' &&
                              !INSTRUCTIONAL_SECTIONS.includes(path)
                            }
                            active={this.props.location.pathname.includes(
                              `/memberships/${path}`
                            )}
                            style={{
                              width: `${100 / MEMBERSHIPS_SECTIONS.length}%`
                            }}
                            eventKey={path}
                            title={this.props.intl.formatMessage({
                              id: `${ROUTES[path]}_help`
                            })}
                          >
                            <LinkContainer
                              to={`/${this.props.locale}/memberships/${path}`}
                            >
                              <div>
                                <span className="round-tab">
                                  <h5 className="text-icon">
                                    {this.props.intl.formatMessage({
                                      id: path
                                    })}
                                  </h5>
                                  <i
                                    className={`${
                                      SECTIONS_DATA.get(
                                        'INFRASTRUCTURE'
                                      ).tools.find(p => ROUTES[path] === p.name)
                                        .icon
                                    } ${
                                      modal == 'infrastructure' &&
                                      !INSTRUCTIONAL_SECTIONS.includes(path)
                                        ? 'disabled'
                                        : ''
                                    }`}
                                  />
                                </span>
                              </div>
                            </LinkContainer>
                          </NavItem>
                        ))}
                      </Nav>
                    </div>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
            <Col xs={12}>
              <IgPanel style={4} className="panel-fixed-height">
                {modal == 'infrastructure' && this.renderFinishButton()}

                <Switch>
                  <Route
                    path="/:locale?/memberships/affiliation"
                    render={props => {
                      if (affiliationStore.canManage) {
                        tooltipStore.setCurrentSection('affiliation');
                        return <Affiliation {...props} />;
                      }

                      tooltipStore.setCurrentSection('unauthorized');
                      return <Unauthorized {...props} />;
                    }}
                  />
                  <Route
                    path="/:locale?/memberships/memberships"
                    render={props => {
                      if (membersStore.canShow) {
                        tooltipStore.setCurrentSection('members');
                        return <Members {...props} />;
                      }

                      tooltipStore.setCurrentSection('unauthorized');
                      return <Unauthorized {...props} />;
                    }}
                  />
                  <Route
                    path="/:locale?/memberships/boards"
                    render={props => {
                      if (membersStore.canShow) {
                        tooltipStore.setCurrentSection('boards');
                        return <Boards {...props} />;
                      }

                      tooltipStore.setCurrentSection('unauthorized');
                      return <Unauthorized {...props} />;
                    }}
                  />

                  <Route
                    path={`/:locale?/memberships/${TOOLS.IGBUSINESS}`}
                    component={IgBusinessWrapper}
                  />

                  <Route
                    component={BmcBoardWrapper}
                    path={`/:locale(en|es)?/memberships/:layer(${Object.values(
                      STARTUP_SECTIONS
                    ).join('|')})?/bmc_boards/:boardId`}
                  />

                  <Route
                    path="/:locale?/memberships/meetings"
                    render={props => {
                      if (membersStore.canShow) {
                        tooltipStore.setCurrentSection('meetings');

                        return (
                          <IgMeetings
                            {...props}
                            {...this.props}
                            user_locale={this.props.locale}
                          />
                        );
                      }

                      tooltipStore.setCurrentSection('unauthorized');
                      return <Unauthorized {...props} />;
                    }}
                  />

                  <Route
                    path={`/:locale?/memberships/${TOOLS.IGINFRASTRUCTURE}`}
                    render={() => (
                      <Redirect
                        to={`/${this.props.locale}/memberships/infrSection/bmc_boards/${this.props.currentBmcId}/step_mode/key_partners`}
                      />
                    )}
                  />

                  <Redirect
                    to={`/${this.props.locale}/memberships/affiliation`}
                  />
                </Switch>
              </IgPanel>
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}
